import { useState, useEffect } from 'react';

const StepProgress = ({
  currentStep,
  handlePrevStep,
  handleNextStep,
  handleNextViewStep,
  handlePrevViewStep,

  isEdit,
  saleType,
  propertyType,

  handleOneStep,
  handleTwoStep,
  handleThreeStep
}) => {
  const isApartment = propertyType === "Apartment";
  const [animatedStep, setAnimatedStep] = useState(currentStep);
  
  // Animation effect whenever currentStep changes
  useEffect(() => {
    // If it's the first render, don't animate
    if (animatedStep === currentStep) return;
    
    // Set a delay to match the animation duration
    const timer = setTimeout(() => {
      setAnimatedStep(currentStep);
    }, 50);
    
    return () => clearTimeout(timer);
  }, [currentStep]);

  const stepsEditApartment = [
    {
      label: !isEdit ? `Create Basic Info` : `${propertyType} Basic Info`,
      action: handleOneStep,
    },
    {
      label: !isEdit ? `Create Tower Info` : `${propertyType} Tower Info`,
      action: handleTwoStep,
    },
    {
      label: !isEdit ? `Create Unit Info` : `${propertyType} Unit Info`,
      action: handleThreeStep,
    },
  ];

  const stepsEditOther = [
    {
      label: !isEdit ? `Create Basic Info` : `${propertyType} Basic Info`,
      action: handlePrevViewStep,
    },
    {
      label: !isEdit ? `Create Unit Info` : `${propertyType} Unit Info`,
      action: handleNextViewStep,
    },
  ];

  const renderEditSteps = (steps) => (
    <div className="flex items-center justify-start mb-5">
      <div className="text-sm font-medium text-center text-gray-500 w-full">
        <div className="flex flex-wrap -mb-px">
          {steps.map((step, index) => (
            <div 
              key={index} 
              onClick={step.action} 
              className="me-2 cursor-pointer"
            >
              <div
                className={`inline-block text-base p-4 rounded-t-lg transition-all duration-300 ${
                  currentStep === index + 1
                    ? "text-customGreen border-b-2 font-medium border-customGreen"
                    : "text-gray-500 hover:text-gray-700 hover:border-b-2 hover:border-gray-300"
                }`}
              >
                {step.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderCreateSteps = (steps) => (
    <div className="flex items-center justify-center mb-8 mt-2">
      <div className="flex items-center justify-between w-full max-w-2xl relative">
        {steps.map((step, index) => (
          <div
            key={index}
            onClick={index === 0 ? handlePrevStep : step.action}
            className="flex cursor-pointer flex-col items-center z-10 w-1/3"
          >
            <div
              className={`w-9 h-9 border-2 rounded-full flex items-center justify-center font-bold mb-2 transition-all duration-500 ease-in-out transform ${
                currentStep > index 
                  ? "bg-white border-customGreen" 
                  : "bg-gray-300"
              } ${
                currentStep === index + 1 
                  ? "scale-110" 
                  : ""
              }`}
            >
              <div
                className={`h-6 w-6 rounded-full flex items-center justify-center text-[16px] transition-all duration-500 ${
                  currentStep > index 
                    ? "bg-customGreen text-white" 
                    : "bg-gray-300 text-gray-700"
                }`}
              >
                {currentStep > index 
                  ? <span className="animate-fadeIn">✓</span> 
                  : ""}
              </div>
            </div>
            <span className={`text-sm font-medium text-center transition-all duration-300 ${
              currentStep === index + 1 ? "text-customGreen" : ""
            }`}>
              {step.label}
            </span>
          </div>
        ))}
  
        {/* Connector with animation */}
        <div className="absolute top-4 left-[16%] w-[68%] h-0.5 bg-gray-300 z-0">
          <div
            className="h-0.5 bg-customGreen transition-all duration-500 ease-in-out"
            style={{ 
              width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
            }}
          ></div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* Add global keyframe animations */}
      <style jsx global>{`
        @keyframes fadeIn {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        
        @keyframes scaleIn {
          0% { transform: scale(0.8); }
          100% { transform: scale(1); }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.5s ease-in-out;
        }
        
        .scale-enter {
          animation: scaleIn 0.3s ease-in-out;
        }
      `}</style>
      
      {isEdit
        ? renderEditSteps(isApartment ? stepsEditApartment : stepsEditOther)
        : renderCreateSteps(isApartment ? stepsEditApartment : stepsEditOther)}
    </>
  );
};

export default StepProgress;